export const EASYBIB = 'easybib' as const
export const CITATION_MACHINE = 'citationmachine' as const
export const BIBME = 'bibme' as const
export const CHEGG = 'chegg' as const

export type SiteState =
  | typeof EASYBIB
  | typeof CITATION_MACHINE
  | typeof BIBME
  | typeof CHEGG

export interface SiteGtmConfig {
  gtmId: string
  auth: string
  preview: string
}

export type GtmConfig = { [key in SiteState]: SiteGtmConfig }
export interface SiteConfig {
  meBffUrl: string
  baseUrl: string
  cfeUrl: string
  wbeUrl: string
  gtm: SiteGtmConfig
  termsLink: string
  SAProfile: string
  cheggAuthRedirect: string
  accountUrl: string
  helpUrl: string
  capitalizedName: string
  cookieDomain: string
  wtaiUrl: string
  bffUrl: string
  oneGraphUrl: string
  cheggSessionApiUrl: string
  optimizelySdkKey: string
  optimizelyProjectId: string
  cheggEnvUrl: string
  dipApiKey: string
  copyrightStartYear: string
  contentfulSpace: string
  contentfulAccessToken: string
  contentfulEnvironment: string
  checkoutFeatureListEntryId: string
  wfeReleaseTag: string
  upgradeModalTitleExp: boolean
}



// WEBPACK FOOTER //
// ./src/state/site/types.ts